/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/8
 */
import './index.css'
import React from 'react';
import {connect} from 'react-redux';
import Item from './item';
import Dots from '../../../svgs/dots18';

const Header = ({ action, list }) => {
  return <div className="mcycle-step-header" style={{display: action===3 ? 'none': 'block'}}>
    {list.map((item, index) =>{
      if (4 === index + 1) {
        return <Item name={item} number={index + 1} key={index} isAction={index <= action} />;
      }
      return [<Item name={item} number={index + 1} key={0} isAction={index <= action} />, <Dots key={1} />]
    })}
  </div>
};

export default connect(
  state => state.app.navigation
)(Header);



// WEBPACK FOOTER //
// ./src/components/step/header/index.js